// extracted by mini-css-extract-plugin
module.exports = {"Ratio":"styles_Ratio__3AyTY","ratioContainer":"styles_ratioContainer__3Gu29","children":"styles_children__3LEiZ"};